import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
// eslint:disable-next-line:no-shadowed-variable
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { isEnglish } from "../../current-language";
import { IContributionsQuoteDTO } from "../../models/IContributionsQuote";
import { SocialHousingService } from "../../services/social-housing.service";
import { ENUM_ERROR_TYPE } from "../search-location/search-location.component";

const $ = (window as any).$;

@Component({
  selector: "app-result",
  templateUrl: "./result.component.html",
  styleUrls: ["./result.component.scss"],
})
export class ResultComponent implements OnInit, OnChanges {
  @Input() public searchResults: IContributionsQuoteDTO;
  @Input() public error: string;
  public isCalculating = false;
  public formCalcul: UntypedFormGroup;
  public results?: IContributionsQuoteDTO;
  public errorMsg = "";
  public infoType = "territoire";
  public isEn = isEnglish();

  constructor(
    private fb: UntypedFormBuilder,
    private housingService: SocialHousingService,
  ) {}

  public ngOnInit() {}

  public ngOnChanges(changes: SimpleChanges) {}

  public isFamily(): boolean {
    return (
      this.searchResults &&
      this.searchResults.familyComponent &&
      this.searchResults.familyComponent.nbAffordableFamilyUnits > 0
    );
  }

  public isSocial(): boolean {
    // si toutes les valeurs calculées sont 0, ce volet ne s'applique pas
    return [
      this.searchResults.socialComponent.offSiteLivingArea,
      this.searchResults.socialComponent.offSiteLivingAreaPercentage,
      this.searchResults.socialComponent.onSiteLivingArea,
      this.searchResults.socialComponent.onSiteLivingAreaPercentage,
      this.searchResults.socialComponent.monetary,
    ].some((x) => x !== 0);
  }

  public getDensificationZoneName() {
    let name = "";
    switch (this.searchResults.affordableComponent.densityZone.name) {
      case "horsZoneDensification":
        name = this.isEn
          ? "Outside affordable housing zone"
          : "Hors zone de logement abordable";
        break;
      case "10%":
        name = this.isEn
          ? `Affordable housing zone 1`
          : `Zone de logement abordable 1`;
        break;
      case "20%":
        name = this.isEn
          ? `Affordable housing zone 2`
          : `Zone de logement abordable 2`;
        break;
    }

    return name;
  }

  public getErrorMessage(): string {
    let errMsg = this.isEn
      ? "An error has occurred. Please try again."
      : `Une erreur s'est produite. Veuillez réessayer.`;
    if (this.error.indexOf(ENUM_ERROR_TYPE.LOT_NUMBERS) > -1) {
      errMsg = this.isEn
        ? "That lot number does not exist. Please check your information and try again."
        : "Le numéro de lot n’existe pas. Vérifiez vos informations et réessayez.";
    } else if (this.error.indexOf(ENUM_ERROR_TYPE.AREA) > -1) {
      if (this.isEn) {
        errMsg = `The residential area is less than or equal to 18,000 m².
         The by-law for a Diverse Metropolis does not apply to residential projects with a floor area of less than 18 001 m².`;
      } else {
        errMsg = `La superficie résidentielle est inférieure ou égale à 18 000 m².
         Un projet résidentiel de moins de 18 001 m² n’est pas assujetti au Règlement pour une métropole mixte.`;
      }
    } else if (this.error.indexOf(ENUM_ERROR_TYPE.DWELLINGS) > -1) {
      if (this.isEn) {
        errMsg = `The number of dwellings is 0. The project is not subject to the By-law for a Diverse Metropolis.`;
      } else {
        errMsg = `Le nombre de logements est de 0. Le projet n'est pas assujetti au Règlement pour une métropole mixte.`;
      }
    }
    return errMsg;
  }
}
